<template>
  <b-modal
    v-model="visible"
    title="Tạo phiếu outsource"
    size="lg"
    @hidden="onHidden"
  >
    <template v-if="warranty">
      <!-- Thông tin máy (readonly) -->
      <div class="border rounded p-3 mb-3 bg-light">
        <h6 class="font-weight-bold mb-2">Thông tin máy</h6>
        <b-row>
          <b-col md="6">
            <p class="mb-1">
              <b>Mã phiếu bảo hành: </b>
              <span class="text-primary font-weight-bold hover-link">{{ warranty.code }}</span>
            </p>
            <p class="mb-1"><b>Tên hàng:</b> {{ warranty.productName }}</p>
            <p class="mb-1"><b>IMEI:</b>{{ warranty.imeiCode }}</p>
          </b-col>
          <b-col md="6">
            <p class="mb-1">
              <b>Khách hàng + SĐT:</b> {{ warranty.customerName }} — {{ warranty.customerPhone }}
            </p>
            <p class="mb-1">
              <b>Lỗi mô tả hiện tại:</b>
              {{ warrantyIssueSummary }}
            </p>
          </b-col>
        </b-row>
      </div>
      <!-- Form gửi đi -->
      <b-form>
        <b-form-group
          label="Nhà cung cấp"
          label-class="font-weight-bold"
          class="required-control"
        >
          <SupplierAutosuggest
            v-model="form.providerId"
            placeholder="tên nhà cung cấp"
            :active-only="true"
          />
        </b-form-group>
        <b-row>
          <b-col
            cols="12"
            md="4"
          >
            <b-form-group
              label="Ngày gửi"
              label-class="font-weight-bold"
              class="required-control"
            >
              <date-picker
                v-model="form.sentDate"
                class="form-control form-control-sm"
                :config="dpConfigs.date"
                placeholder="Chọn ngày"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="4"
          >
            <b-form-group label="Ngày hẹn trả">
              <date-picker
                v-model="form.expectedReceiveDate"
                class="form-control form-control-sm"
                :config="dpConfigs.date"
                placeholder="Chọn ngày"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="4"
          >
            <b-form-group label="Chi phí dự kiến">
              <BInputNumber
                :value="form.estimatedCost"
                @valueChange="(v) => (form.estimatedCost = v)"
                size="sm"
                placeholder="0"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-group label="Lý do outsource / mô tả lỗi gửi đi">
          <b-form-textarea
            v-model="form.issueDescription"
            rows="3"
            placeholder="Nhập mô tả"
          />
        </b-form-group>
      </b-form>
    </template>
    <template #modal-footer>
      <b-button
        size="sm"
        variant="secondary"
        @click="hide"
        >Huỷ</b-button
      >
      <SaveButton
        :is-busy="isBusy"
        text="Tạo phiếu"
        variant="primary"
        size="sm"
        @click="onSubmit"
      />
    </template>
  </b-modal>
</template>

<script>
import moment from 'moment'
import timeUtils from '@/utils/date'
import { makeToastFaile } from '@/utils/common'
import BInputNumber from '@/view/base/bootstrap/BInputNumber.vue'
import SupplierAutosuggest from '@/view/components/suppliers/SupplierAutosuggest.vue'
import SaveButton from '@/view/components/common/SaveButton.vue'
import { createOutsource } from '../warrantyOutsourceApi'

export default {
  name: 'OutsourceFormModal',
  components: { BInputNumber, SupplierAutosuggest, SaveButton },
  props: {
    warranty: { type: Object, default: null },
  },
  data() {
    return {
      visible: false,
      isBusy: false,
      dpConfigs: timeUtils.DP_CONFIG,
      form: {
        providerId: null,
        sentDate: null,
        expectedReceiveDate: null,
        estimatedCost: null,
        issueDescription: '',
      },
    }
  },
  computed: {
    warrantyIssueSummary() {
      const w = this.warranty
      if (!w) return '—'
      const latest = Array.isArray(w.warrantyRepairs) && w.warrantyRepairs.length ? w.warrantyRepairs[0] : null
      return latest?.repairSolution || w.issueDescription || '—'
    },
  },
  methods: {
    async show() {
      this.visible = true
      const today = moment().toDate()
      this.form = {
        providerId: null,
        sentDate: today,
        expectedReceiveDate: null,
        estimatedCost: null,
        issueDescription: this.warrantyIssueSummary === '—' ? '' : this.warrantyIssueSummary,
      }
      // SupplierAutosuggest tự handle search-on-demand, không cần pre-load
    },
    hide() {
      this.visible = false
    },
    onHidden() {
      this.$emit('hidden')
    },
    validate() {
      const messages = []
      if (!this.form.providerId) messages.push('Bắt buộc chọn nhà cung cấp')
      if (!this.form.sentDate) messages.push('Bắt buộc chọn ngày gửi')
      messages.forEach((msg) => makeToastFaile(msg))
      return messages.length === 0
    },
    async onSubmit() {
      if (!this.validate() || !this.warranty || !this.warranty.id || this.isBusy) return
      this.isBusy = true
      try {
        const sentDate =  timeUtils.formatDBDate(this.form.sentDate)
        const expectedReceiveDate = timeUtils.formatDBDate(this.form.expectedReceiveDate)
        await createOutsource({
          warrantyId: Number(this.warranty.id),
          providerId: Number(this.form.providerId),
          sentDate,
          expectedReceiveDate: expectedReceiveDate || null,
          estimatedCost:
            this.form.estimatedCost != null && this.form.estimatedCost !== ''
              ? Number(this.form.estimatedCost)
              : null,
          issueDescription: this.form.issueDescription?.trim() || null,
        })
        this.hide()
        this.$emit('created')
      } catch {
        // BE error đã được handleError trong warrantyOutsourceApi
      } finally {
        this.isBusy = false
      }
    },
  },
}
</script>
